/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Pagination info
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * Number of elements on this page
     * @type {number}
     * @memberof Pagination
     */
    count?: number;
    /**
     * Total number of elements
     * @type {number}
     * @memberof Pagination
     */
    totalCount?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof Pagination
     */
    page?: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof Pagination
     */
    totalPages?: number;
    /**
     * Indicates if there is next page
     * @type {boolean}
     * @memberof Pagination
     */
    hasNext?: boolean;
    /**
     * Indicates if there is previous page
     * @type {boolean}
     * @memberof Pagination
     */
    hasPrevious?: boolean;
}

/**
 * Check if a given object implements the Pagination interface.
 */
export function instanceOfPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginationFromJSON(json: any): Pagination {
    return PaginationFromJSONTyped(json, false);
}

export function PaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
    };
}

export function PaginationToJSON(value?: Pagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'totalCount': value.totalCount,
        'page': value.page,
        'totalPages': value.totalPages,
        'hasNext': value.hasNext,
        'hasPrevious': value.hasPrevious,
    };
}

